import { AddressBook, AddressBookTypeEnum } from '../../../generated';
import { EMPTY_GUID } from '../../../constants';

export const isInNetwork = (addressBook: AddressBook) =>
  addressBook.addressBookTypeEnum === AddressBookTypeEnum.Global &&
  addressBook.addressBookID === EMPTY_GUID;
